import { GetApiData } from "../../utils/http-client";
// const companyId = localStorage.getItem('selectedCompany');
export const getStatsData = function (startDate, endDate, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/${companyId}/${query}`, 'GET', null, true);
}

export const getPlacementData = function (companyId, startDate, endDate, page = 1, limit = 20, view = 'monthly', selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}&filterType=${view}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }

    return GetApiData(`/stats/tablePlacement/${companyId}${query}`, 'GET', null, true);
}
export const getPlacementDataCSV = function (companyId, startDate, endDate, view = 'monthly', selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}&filterType=${view}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }

    return GetApiData(`/stats/tablePlacementXls/${companyId}${query}`, 'GET', null, true);
}

export const getCtrStatsData = function (startDate, endDate, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/ctr/${companyId}/${query}`, 'GET', null, true);
}
export const getChartData = function (startDate, endDate, companyId, selectedCampagins) {
    // const query = `?startDate=${startDate}&endDate=${endDate}`;
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/chart/${companyId}/${query}`, 'GET', null, true);
}
export const getChartCountry = function (startDate, endDate, companyId, selectedCampagins) {
    // const query = `?startDate=${startDate}&endDate=${endDate}`;
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/countryDistribution/${companyId}/${query}`, 'GET', null, true);
}
export const getChartAttribute = function (startDate, endDate, companyId, selectedCampagins) {
    // const query = `?startDate=${startDate}&endDate=${endDate}`;
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/attributeChart/${companyId}/${query}`, 'GET', null, true);
}
export const getDayChartData = function (startDate, endDate, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/dayChart/${companyId}/${query}`, 'GET', null, true);
}
export const getChartDataPie = function (startDate, endDate, companyId, selectedCampagins) {
    // const query = `?startDate=${startDate}&endDate=${endDate}`;
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/pieChart/${companyId}/${query}`, 'GET', null, true);
}
export const getChartDataPiePerDay = function (startDate, endDate, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/pieChartPerDay/${companyId}/${query}`, 'GET', null, true);
}
export const getCategoryChartDataPie = function (startDate, endDate, companyId, selectedCampagins) {
    // const query = `?startDate=${startDate}&endDate=${endDate}`;
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/pieCategoryChart/${companyId}/${query}`, 'GET', null, true);
}
export const getTopChart = function (startDate, endDate, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/getTop/${companyId}/${query}`, 'GET', null, true);
}
export const getCityChart = function (startDate, endDate, companyId, selectedMap, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}&country=${selectedMap}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/cityData/${companyId}/${query}`, 'GET', null, true);
}
export const getCountryChart = function (startDate, endDate, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/countryData/${companyId}/${query}`, 'GET', null, true);
}
export const getTableData = function (startDate, endDate, page, limit, companyId, selectedCampagins, week) {
    let query = `?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    if (week === true) {
        query += `&week=${false}`;
    }
    return GetApiData(`/stats/table/${companyId}/${query}`, 'GET', null, true);
};
export const getTableCsv = (startDate, endDate, companyId, selectedCampagins, week) => {
    // const query = `?startDate=${startDate}&endDate=${endDate}`;
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    if (week === true) {
        query += `&week=${false}`;
    }
    return GetApiData(`/stats/tablexls/${companyId}${query}`, 'GET', null, true, '', 'blob');
};

export const getTablePerDayCsv = (startDate, endDate, companyId, selectedCampagins) => {
    // const query = `?startDate=${startDate}&endDate=${endDate}`;
    let query = `?startDate=${startDate}&endDate=${endDate}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/tablePerDayxls/${companyId}${query}`, 'GET', null, true, '', 'blob');
};
export const getTableDataPerDay = function (startDate, endDate, page, limit, companyId, selectedCampagins) {
    // const query = `?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`;
    let query = `?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/tablePerDay/${companyId}/${query}`, 'GET', null, true);
};
export const getCategoryTable = function (startDate, endDate, page, limit, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/categoryTable/${companyId}/${query}`, 'GET', null, true);
}
export const getCreativeTableData = function (startDate, endDate, page, limit, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/creativeTable/${companyId}/${query}`, 'GET', null, true);
}
export const getStateTableData = function (startDate, endDate, page, limit, companyId, selectedCampagins) {
    let query = `?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`;
    if (selectedCampagins?.length > 0) {
        query += `&campaginFilter=${encodeURIComponent(JSON.stringify(selectedCampagins))}`;
    }
    return GetApiData(`/stats/stateData/${companyId}/${query}`, 'GET', null, true);
}
export const getCompanyMapCountry = function (companyId) {
    return GetApiData(`/company/mapshow/${companyId}`, 'GET', null, true);
}
export const getCampaignFilter = function (companyId) {
    return GetApiData(`/company/filtershow/${companyId}`, 'GET', null, true);
}
